import { z } from 'zod';

import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#einkunftausnebentaetigkeit

	{
        "antragstellerIds": [ String ],
        "beginnDerTaetigkeit": "YYYY-MM-DD",
        "betragMonatlich": BigDecimal
    }

*/
export const schemaEuropaceUpdateEinkunftAusNebentaetigkeit = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    beginnDerTaetigkeit: z.optional(z.string().regex(regex_iso_date)),
    betragMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateEinkunftAusNebentaetigkeit = z.infer<
    typeof schemaEuropaceUpdateEinkunftAusNebentaetigkeit
>;
